import {decorate, observable} from 'mobx';
import {faTag} from '@fortawesome/free-solid-svg-icons';
import {BaseModel} from './base';
import i18n from '../i18n/i18n';
import {displayablePropertyParam} from './displayablePropertyParam';
import {displayableProperty} from './displayableProperty';
import {transformation} from '../utils/transformations';
import {datetimeFormat} from '../config/moment';

export class InspectionLot extends BaseModel {
  static faIcon = faTag;

  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);
    this.order = rootStore.orderStore.getById(this.orderId);
    this.deactivatedByUser = rootStore.userStore.getById(this.deactivatedBy);
  }

  displayableProperties = [
    displayableProperty({
      key: 'lotNo',
      title: i18n.t('inspectionLot.model.attributes.lotNo'),
      params: [displayablePropertyParam({path: 'lotNo'})],
    }),
    displayableProperty({
      key: 'order',
      title: i18n.t('order.model.attributes.no'),
      params: [displayablePropertyParam({path: 'order.no'})],
    }),
    displayableProperty({
      key: 'validStart',
      title: i18n.t('inspectionLot.model.attributes.validStart'),
      params: [{path: 'validStart', transform: transformation.datetime({format: datetimeFormat})}],
    }),
    displayableProperty({
      key: 'validEnd',
      title: i18n.t('inspectionLot.model.attributes.validEnd'),
      params: [{path: 'validEnd', transform: transformation.datetime({format: datetimeFormat})}],
    }),
    displayableProperty({
      key: 'deactivatedAt',
      title: i18n.t('inspectionLot.model.attributes.deactivatedAt'),
      params: [{path: 'deactivatedAt', transform: transformation.datetime({format: datetimeFormat})}],
      raw: false,
    }),
    displayableProperty({
      key: 'deactivatedBy',
      title: i18n.t('inspectionLot.model.attributes.deactivatedBy'),
      params: [displayablePropertyParam({path: 'deactivatedByUser.username'})],
    }),
    displayableProperty({
      key: 'deactivatedReason',
      title: i18n.t('inspectionLot.model.attributes.deactivatedReason'),
      params: [displayablePropertyParam({path: 'deactivatedReason'})],
      raw: false,
    }),
  ];
}

decorate(InspectionLot, {
  id: observable,
  orderId: observable,
  order: observable,
  lotNo: observable,
  validStart: observable,
  validEnd: observable,
  deactivatedBy: observable,
  deactivatedByUser: observable,
  deactivatedAt: observable,
  deactivatedReason: observable,
});

export const InspectionLotOrigin = {
  order: 'ERP-QM',
  notOrder: 'ERP-PM',
};
